eshopApp.controller('SubProductsController', ['$scope', '$http', 'alertMessage', function($scope, $http, alertMessage) {

	// Helpers
	$scope.helper = CustomNameSpace.helpers;

	$scope.parent_product_id = parseInt(angular.element('.module_subproducts #parent_product_id').val());
	$scope.selected_product_id = parseInt(angular.element('.module_subproducts #selected_product_id').val());

	// Get SubProducts
	$scope.fetch = function(){

		$scope.spinner = true;

		$http.get('/m/products/parent/'+$scope.parent_product_id).success(function(response){
			$scope.products = response;
	  	}).error(function(){
	  		alertMessage.set(generic.error, 'error');
	  	}).finally(function(){
	  		$scope.spinner = false;
	  	});
	};

	if ($scope.parent_product_id !== 0) {
		$scope.fetch(); 
	}

}]);